import localforage from "localforage";

import { LocalStorageKey } from "@/modules/local-storage/constants";
import { LocalStoragePendingEphemeralRouteAction } from "@/modules/local-storage/types";
import { logger } from "@/modules/logger";
import { objectModule } from "@/modules/object";

export const _writeLocalStoragePendingEphemeralRouteAction = async (value: {
  path: string;
  data: string;
}): Promise<void> => {
  try {
    const record: LocalStoragePendingEphemeralRouteAction = {
      path: value.path,
      data: value.data,
    };

    await localforage.setItem<LocalStoragePendingEphemeralRouteAction>(
      LocalStorageKey.PendingEphemeralRouteAction,
      record
    );
  } catch (unknownErr) {
    const err = unknownErr as Error;

    logger.warn({
      message: "[_writeLocalStoragePendingEphemeralRouteAction] Failed.",
      info: {
        err: objectModule.safeErrorAsJson(err),
      },
    });
  }
};

export const _clearLocalStoragePendingEphemeralRouteAction = async (): Promise<void> => {
  try {
    await localforage.removeItem(LocalStorageKey.PendingEphemeralRouteAction);
  } catch (unknownErr) {
    const err = unknownErr as Error;

    logger.warn({
      message: "[_clearLocalStoragePendingEphemeralRouteAction] Failed.",
      info: {
        err: objectModule.safeErrorAsJson(err),
      },
    });
  }
};

export const _readLocalStoragePendingEphemeralRouteAction =
  async (): Promise<LocalStoragePendingEphemeralRouteAction> => {
    try {
      const result = await localforage.getItem<LocalStoragePendingEphemeralRouteAction>(
        LocalStorageKey.PendingEphemeralRouteAction
      );

      if (!result || !result.path || !result.data) {
        return null;
      }

      return {
        path: result.path,
        data: result.data,
      };
    } catch (unknownErr) {
      const err = unknownErr as Error;

      logger.warn({
        message: "[_readLocalStoragePendingEphemeralRouteAction] Failed.",
        info: {
          err: objectModule.safeErrorAsJson(err),
        },
      });

      return null;
    }
  };
